import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { getRawMaterialById } from '../services/po.stock.service';
import notistack from 'pages/Core/Notistack';
import DataGrid, { Column } from 'devextreme-react/cjs/data-grid';

interface ViewRawMaterialProp {
    isViewOpen: boolean;
    id: number | string | null;
    onClose: () => void;
}

const ViewRawMaterial: React.FC<ViewRawMaterialProp> = ({ isViewOpen, id, onClose }) => {
    const [data, setData] = useState<any[]>([])
    const getDetails = async () => {
        try {

            const response = await getRawMaterialById({ id })
            setData(response.data)
        } catch (error: any) {
            notistack.error(error)
        }
    }
    useEffect(() => {
        if (isViewOpen && id)
            getDetails()
    }, [isViewOpen, id])

    return (
        <>
            <Modal
                show={isViewOpen}
                onHide={onClose}
                backdrop="static"
                size="lg"
                dialogClassName="modal-dialog-centered"
                style={{ backgroundColor: `rgba(0, 0, 0, 0.4)` }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Raw Materials</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                    <DataGrid
                        dataSource={data}
                        showRowLines
                        showBorders
                        keyExpr="id"
                        width={'100%'}
                    >
                        <Column dataField="mf" caption="MF" width={100} cssClass='text-center' />
                        <Column dataField="rowType" caption="Raw Type" width={100} cssClass='text-center' />
                        <Column dataField="weight" caption="Gross Weight" format="#0.000" width={150} cssClass='text-center' />
                        <Column
                            dataField="karat"
                            caption="Karat"
                            width={100}
                            cssClass='text-center'
                        />
                        <Column dataField="qty" caption="Qty" width={100} />
                        <Column dataField="stoneWeight" caption="Stone Wt" width={100} cssClass='text-center'
                            format="#0.000"
                        />
                    </DataGrid>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewRawMaterial
